import React, { useState } from "react";
import "./forgotPassword.scss";
import logo from "../../assets/images/townOf1000Trails.svg";
import { Card, CardBody, Label } from "reactstrap";
import { useTranslation } from "react-i18next";
import HookForm from "../../components/hookForm/hookForm";
import TextField from "../../components/textField/textField";
import Constant from "../../util/constant";
import CustomButton from "../../components/customButton/customButton";
import { useNavigate } from "react-router-dom";
import { showToast } from "../../store/features/toast/toastSlice";
import { useDispatch } from "react-redux";
import axios from "axios";
import { FORGOT } from "../../api/endPoint";
import { Helmet } from "react-helmet";

const ForgotPassword: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const loginForm = {
    email: {
      name: "email",
      validate: {
        required: {
          value: true,
        },
        pattern: {
          value: Constant.REGEX.EMAIL,
          message: t("PLEASE_ENTER_A_VALID_EMAIL_ADDRESS"),
        },
      },
    },
  };

  const onSubmit = async (formData: any) => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}${FORGOT}`,
        {
          email: formData.email,
        }
      );

      // Store OTP and expiry time in local storage
      const { OTP, OTPExpiresIn } = response.data.data;
      localStorage.setItem("OTP", OTP.toString());
      localStorage.setItem("OTPExpiresIn", OTPExpiresIn.toString());

      // Handle success response
      dispatch(
        showToast({
          show: true,
          message: response.data.message || "OTP sent successfully!",
          type: "success",
        })
      );

      // Navigate to OTP verification page
      navigate("/otp-verification");
    } catch (error: any) {
      // Handle error
      dispatch(
        showToast({
          show: true,
          message: error.response?.data?.message || "Failed to send OTP!",
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  const handleEmailChange = (value: string) => {
    localStorage.setItem("forgotPasswordEmail", value); // Save email as a plain string
  };
  const getInitialFormData = (): string | null => {
    const savedData = localStorage.getItem("forgotPasswordEmail");
    return savedData || ""; // Return the raw string or an empty string
  };

  return (
    <>
      <Helmet>
        <title>Forgot Password | Town of 1000 Trails Admin Panel</title>
        <meta
          name="description"
          content="Reset your password on this page. If login issues persist, please contact the development team."
        />
      </Helmet>
      <div className="forgot-container">
        <div>
          <img className="pt-50 pb-30 logo" src={logo} alt="logo" />
          <Card className="overflow-hidden cardStyle" color="white">
            <CardBody className="d-flex  bg-indigo justify-content-between p-24 ">
              <div className="d-flex flex-column">
                <h4 className="text-left text-primary">
                  {t("FORGOT_PASSWORD")}
                </h4>
                <span className="title text-primary">
                  {t("NO_WORRIES_WE_WILL_HELP_YOU_WITH_THAT")}
                </span>
              </div>
              <div className="iconStyle">
                <i className="icon icon-key"></i>
              </div>
            </CardBody>
            <CardBody className="text-center px-24 py-32">
              <HookForm
                defaultForm={{ email: getInitialFormData() || "" }}
                onSubmit={async (formData) => {
                  console.log("formData: ", formData);
                  onSubmit(formData);
                }}
              >
                {(formMethod) => {
                  return (
                    <>
                      <div className="loginWrapper ">
                        <div className="texFeildWrapper mb-4">
                          <div className="d-flex">
                            <Label className="lable">
                              {t("EMAIL_ADDRESS")}
                            </Label>{" "}
                            <span className="redStar mx-2">*</span>
                          </div>
                          <TextField
                            formMethod={formMethod}
                            rules={loginForm.email.validate}
                            name={loginForm.email.name}
                            errors={formMethod?.formState.errors}
                            autoFocus={true}
                            required={true}
                            maxLength={256}
                            disabled={loading}
                            type="email"
                            placeholder={t("ENTER_EMAIL_ADDRESS")}
                            value={formMethod.getValues(loginForm.email.name)}
                            onChange={(e) => {
                              const trimmedValue = e.target.value
                                .replace(/\s/g, "")
                                .toLowerCase();
                              formMethod.setValue(
                                loginForm.email.name,
                                trimmedValue
                              ); // Update and validate
                              handleEmailChange(trimmedValue);
                            }}
                          />
                        </div>
                      </div>
                      <div className="submitDiv mb-2">
                        <CustomButton
                          className="btn btn-danger text-white btn-lg w-100 text-center justify-content-center"
                          type="submit"
                          title={t("NEXT")}
                          loading={loading}
                          disabled={!formMethod?.formState.isValid}
                        />
                      </div>
                      <div>
                        <CustomButton
                          color="primary"
                          onClick={() => navigate("/")}
                          className="btn btn-transparent d-flex justify-content-center align-items-center mt-3 w-100 p-0"
                          title=""
                        >
                          <i className="me-2 icon icon-chevron-left"></i>{" "}
                          {t("BACK_TO_LOGIN")}
                        </CustomButton>
                      </div>
                    </>
                  );
                }}
              </HookForm>
            </CardBody>
          </Card>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
